import { jsx as _jsx } from "react/jsx-runtime";
import ProductCard from './ProductCard';
import { useTranslation } from '../lib/language';
export default function ProductGrid({ products }) {
    const { t } = useTranslation();
    if (products.length === 0) {
        return (_jsx("div", { className: "text-center py-12", children: _jsx("p", { className: "text-gray-600", children: t('products.noProducts') }) }));
    }
    return (_jsx("div", { className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6", children: products.map((product) => (_jsx(ProductCard, { product: product }, product.id))) }));
}
